import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CareerSidebar"] */ "/app/src/components/new/CareerSidebar/CareerSidebar.tsx");
